import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

const Lnb = () => {
    const [host, setHost] = useState(window.location.hostname.split('.')[0])

    useEffect(() => {
        const hosting = window.location.hostname.split('.')[0]
        if(hosting === 'stdpc') {
            const fullHost = window.location.href.split('/')
            if(fullHost[fullHost.length-1].substring(0, 3) === '203') {
                setHost('game')
            } else {
                setHost(hosting)
            }
        } else {
            setHost(hosting)
        }
    })
    // const host = 'm'

    const data = [
        {
            name: '홈',
            host: 'm',
            link: process.env.REACT_APP_WWW_URL
        },{
            name: 'PC견적',
            host: 'pc',
            link: process.env.REACT_APP_PC_URL
        },{
            name: '조립PC',
            host: 'stdpc',
            link: process.env.REACT_APP_STDPC_URL,
            // ico: 'b'
        },{
            name: '게임별PC',
            host: 'game',
            link: process.env.REACT_APP_STDPC_URL + '/list/2030000000',
            // ico: 'b'
        },
        // {
        //     name: '노트북',
        //     host: 'notebook',
        //     link: process.env.REACT_APP_NOTEBOOK_URL,
        //     // ico: 'n'
        // },
        {
            name: '톡톡 커뮤니티',
            host: 'talk',
            link: process.env.REACT_APP_TALK_URL,
            ico: 'new_2'
        },{
            name: '행복핫딜',
            host: 'deal',
            link: process.env.REACT_APP_DEAL_URL,
            // ico: 'n'
        },{
            name: '이벤트&기획전',
            host: 'event',
            link: process.env.REACT_APP_EVENT_URL
        },
    ]

    if (data.findIndex(v => v.host === host) === -1) return null
    return (
        <Style className="header_component_lnb">
            <ul>
                {data.map(v => (
                    <li>
                        <Alink href={v.link} className={host === v.host ? 'active' : ''}>
                            {v.name}
                            {/*{v.ico && <img src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v5/ic_${v.ico}.png`} alt="" width="14" height="18" />}*/}
                            {v.ico && <img src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v5/ic_${v.ico}.png`} alt={v.ico}/>}
                        </Alink>
                    </li>
                ))}
            </ul>
        </Style>
    )
}

const Style = styled.div`
    height: 35px;
    margin: 6px 0 0;

    ul {
        display: flex;
        overflow-x: auto;
        overflow-y: hidden;
        white-space: nowrap;
        padding: 0 14px;

        li {
            &:not(:first-child) {
                margin: 0 0 0 16px;
            }
            a {

            }
        }
    }
`
const Alink = styled.a`
    display: block;
    position: relative;
    height: 35px;
    padding: 0 3px;
    line-height: 24px;
    font-size: 16px;
    font-weight: 700;
    border-bottom: 3px solid transparent;

    &.active {
        border-color:  #418ded;
        color: #418ded;
    }
    img {
        //position: absolute;
        //top: 2px;
        //left: -12px;
        max-width:inherit;
        margin-left:2px;
    }
`

export default Lnb



// WEBPACK FOOTER //
// ./src/m_header/components/lnb/index.js